{
  "version": 1,
  "asset_id": "3a861e36-f767-4e85-9e5c-d7680b6a1e40",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/3a861e36-f767-4e85-9e5c-d7680b6a1e40/hartmann-smartlane.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/3a861e36-f767-4e85-9e5c-d7680b6a1e40/hartmann-smartlane.png",
  "original_filename": "hartmann-smartlane.png",
  "size": 1657013,
  "content_type": "image/png",
  "created_at": "2026-06-25T11:11:05Z"
}
